module.exports = require("core-js/library/fn/array/is-array");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/array/is-array.js
// module id = IG2y
// module chunks = 0